import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ty7kjf8pc: FaireProductEntity = {
  token: "p_8ty7kjf8pc",
  type: "product",
  name: "Hudson Pillow Cover",
  brandToken: "b_bzvh3j6vb7",
  brandName: "Rug & Weave Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/dcf0fbbb58d22096ab29eec46899afb377e17ea6d0a3a2e69b583fa8d49b42b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d004108cf34101df78e244661d93d5d57847b4b2b493f4b0eb83011aaa3f111f.jpeg",
    "https://cdn.faire.com/fastly/627d1bffee9b350134c149a3f7b32d728bf02ca3f52bebf092370328df0cf40d.jpeg",
    "https://cdn.faire.com/fastly/224e70573973e919740f25788d793d6230c507f2ee680113d9521059d76783a8.jpeg",
    "https://cdn.faire.com/fastly/6e86146c1cfed1bed66be3f349b6cbdd1a04e8081783bc070c5151391cdfe911.jpeg",
    "https://cdn.faire.com/fastly/1647af4f0accdfb730b8937705ccbb6c1361ec24ae4bc28eb7e7ed398f2004f0.jpeg",
    "https://cdn.faire.com/fastly/d778c245ff3568c33a70d3c2bc491da11e1f71e7d377a0b802362fea921ec093.jpeg",
    "https://cdn.faire.com/fastly/68d3d70001bc847602502887b0f722098d0a508d8245613aedcd78b6d52ff21c.jpeg",
  ],
  priceDollars: 41,
  description:
    "Meet our new moody stripe - Hudson! A simple brown stripe in a linen blend creates a classic statement.  Available in two square sizes, this pillow works with a wide assortment of other covers acting as a staple neutral that works in many stylings!\n\n*Inserts can be added to your order separately via our Insert product page.\n\nDetails:\n-fully lined\n-exposed brass YKK zipper closure\n-sold in set of 2\n\nMaterials:\n-outer: 20% linen, 50% rayon, 30% cotton\n-lining: 100% cotton\n\nCare:\n-we recommend spot clean or dry clean for this item\n\nDesigned and made in-house by Rug & Weave Studio, in Canada.",
  tags: [],
  msrpDollars: 74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:59.283Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
